/* eslint-disable camelcase */
/* eslint-disable no-magic-numbers */
import React, { PureComponent } from "react"
import { Route, Switch, Link } from "react-router-dom"
import { get, filter, map, find, size, isEmpty } from 'lodash'
import Cookies from "universal-cookie";
import moment from "moment";
import TopNavigation from "../../../../components/TopNavigation/container"
import AdministrationSidebarNavigation from "../../../../components/AdministrationSidebarNavigation/component"
import { ClientsColorIcon, CloseIcon } from "../../../../components/icons"
import AllClients from './partials/AllClient/component'
import NewClients from './partials/NewClients/component'
import "./styles.scss"
import SelectPageResult from "./partials/layout/SelectPageResult";
import FilterUser from "./partials/layout/FilterUser";
import { SUCCESS } from '../../../../constants/phase';
import ExportClients from '../../../../components/ExportClients'
import { ClientContext } from "./context/ClientContext";

const cookies = new Cookies();
export default class ClientsComponent extends PureComponent {
  constructor(props) {
    super(props)
      
    this.state = {
      timingsData: [
        { id: 1, name: "ASAP" }, { id: 2, name: "Uncertain" }, { id: 3, name: "Spring 2021" },
        { id: 4, name: "Fall 2021" }, { id: 5, name: "Spring 2022" }, { id: 6, name: "Fall 2022" },
        { id: 7, name: "Spring 2023" }, { id: 8, name: "Fall 2023" }, { id: 9, name: "Spring 2024" },
        { id: 10, name: "Fall 2024" }, { id: 11, name: "Spring 2025" }, { id: 12, name: "Fall 2025" },
        { id: 13, name: "Spring 2026" }, { id: 14, name: "Fall 2026" }
      ],
      isLoading: true,
      clientType: "all_clients",
      visible: false,
      resultEntry: 20,
      activeClientCount: 0,
      closedClientCount: 0,
      noFollowUp: false,
      noStatus: false,
      noTownTour: false,
      hideInactive: false,
      overdueFollowUps: false,
      clientStatus: [],
      clientSuburb: [],
      clientStrategist: [],
      clientTiming: [],
      clientAgent: [],
      status: false,
      clientLimit: 20,
      strategists: false,
      timings: false,
      statusDropdown: false,
      strategistsDropDown: false,
      timingsDropDown: false,
      filterCount: 0,
      activePage: 1,
      filterSearch: [],
      searchStatus: "",
      sortByKey: "",
      sortByType: 0,
      startDate: "",
      endDate: "",
      selectedClientStatus: [],
      selectedClientStrategists: [],
      selectedClientTimings: [],
      selectedClientSuburbs: [],
      selectedClientAgents: [],

      // For Handling ClientContext
      isClientDataFetching: false
    }
    this.filterUserRef = React.createRef();
    this.allClientRef = React.createRef();
    this.newClientRef = React.createRef();
  }

  

  componentDidMount() {
    this.props.getFilterParams();
    const user = cookies.get("user");
    document.body.scrollTop = 0
    if (user) {

      const localclientdata = JSON.parse(localStorage.getItem('clientFilterData'))
      if (!get(this.props, 'location.state.filter', false)) {
        if (localclientdata && localclientdata !== null && localclientdata !== '') {
          this.setState(
            {
              isLoading: true,
              selectedClientStatus: localclientdata.clientStatus,
              selectedClientStrategists: localclientdata.clientStrategist,
              selectedClientTimings: localclientdata.clientTiming,
              selectedClientSuburbs: localclientdata.clientSuburb,
              selectedClientAgents: localclientdata.clientAgent,
              clientType: 'all_clients',
              clientAgent: localclientdata.clientAgent,
              clientStatus: localclientdata.clientStatus,
              status: isEmpty(localclientdata.clientStatus) ? false : true,
              statusDropdown: isEmpty(localclientdata.clientStatus) ? false : true,
              clientSuburb: localclientdata.clientSuburb,
              clientStrategist: localclientdata.clientStrategist,
              clientTiming: localclientdata.clientTiming,
              hideInactive: localclientdata.hideInactive,
              pageLimit: localclientdata.pageLimit,
              activePage: localclientdata.activePage,
              startDate: localclientdata.startDate ? localclientdata.startDate : '',
              endDate: localclientdata.endDate ? localclientdata.endDate : '',
              filterCount: localclientdata && localclientdata.filterCount ? localclientdata.filterCount : 0,
            })
        }
      }
    }
  }
  static getDerivedStateFromProps(props, state) {
    let states = { ...state }
    if (props.filterClientsPhase === SUCCESS) {
      props.clearPhase()
      states = { ...states, isLoading: false }
    }
    if (props.location.pathname !== '') {
      let clientType = 'all_clients'
      if (['/strategist/clients/new-clients', '/strategist/clients'].includes(props.location.pathname)) {
        clientType = 'my_clients'
      }
      states = { ...states, isLoading: false, clientType }
    }
    return states
  }
  componentDidUpdate(prevProps, prevState) {
    if(this.props.clientsData && this.props.clientsData.users && prevProps.clientsData && prevProps.clientsData.users && this.props.clientsData.users.length !== prevProps.clientsData.users.length){
      this.setState({isClientDataFetching: false})
    // } else if(this.props.clientsData && this.props.clientsData.users && prevProps.clientsData && prevProps.clientsData.users && this.props.clientsData.users.length === prevProps.clientsData.users.length && this.props.filterClientsPhase === SUCCESS) {
    } else if(this.props.clientsData && this.props.clientsData.users && prevProps.clientsData && prevProps.clientsData.users && this.props.clientsData.users.length === prevProps.clientsData.users.length) {
      this.setState({isClientDataFetching: false})
    }
  }
  
  handleRouteChange = (path) => this.props.history.push(`/strategist/clients/${path}`)

  handleResultChange = (resultEntry) => this.setState({ resultEntry }, () => {
    this.fetchFilterResult()
  })

  //changeProps for mobile function
  changePropsForMobile(e) {
    let path = e.target.value
    this.setState({ clientType: path })
    if (path === 'my_clients') {
      this.props.history.push(`/strategist/clients/new-clients`)
    } else if (path === 'all_clients') {
      this.props.history.push(`/strategist/clients/all-clients`)
    }
  }

  fetchFilterResult = (params) => {
    const { clientType, clientAgent, filterCount, activePage, clientStatus, clientStrategist, clientTiming, clientSuburb, sortByType, sortByKey, hideInactive, resultEntry } = this.state

    const localclientdata = JSON.parse(localStorage.getItem('clientFilterData'))

    const data = {
      clientType,
      clientStatus,
      clientSuburb,
      clientAgent,
      clientStrategist,
      clientTiming,
      hideInactive,
      pageLimit: resultEntry,
      activePage,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      ...(localclientdata.sortBy && {sortBy: {key: localclientdata.sortBy.key, type: localclientdata.sortBy.type}})
    }
		this.setState({isLoading: true,isClientDataFetching: params === 'hasParams' ? false : true,}, () => this.props.getClientList(data))
    this.forceUpdate()
    localStorage.setItem('clientFilterData', JSON.stringify({ ...data, filterCount }))
  }

  fetchAlldata = async() => {

    const currentUrl = get(this.props, "location.pathname", "")
    var pageLimit = 7000,
    clientType = 'all_clients'
    if(currentUrl === '/strategist/clients/new-clients' || currentUrl === '/strategist/clients'){
      pageLimit = get(this.props.clientsData, `user_counts.my_clients`, 7000);
      clientType = 'my_clients'
    }
    else 
      pageLimit = get(this.props.clientsData, `user_counts.all_clients`, 7000)

    const { sortByKey, sortByType, startDate, endDate, hideInactive, selectedClientStrategists, selectedClientAgents, selectedClientStatus, selectedClientTimings, selectedClientSuburbs } = this.state

    const params = {
      clientType,
      clientStatus: selectedClientStatus,
      clientSuburb: selectedClientSuburbs,
      clientStrategist: selectedClientStrategists,
      clientTiming: selectedClientTimings,
      clientAgent: selectedClientAgents,
      hideInactive,
      pageLimit,
      activePage: 1,
      startDate,
      endDate,
      sortBy: { key: sortByKey, type: sortByType }
    }

    const allData = await this.props.getClientListApi(params)
    return allData
  }


  filterStrategist = (id, type, e) => {
  
    let { startDate, endDate, selectedClientStatus, selectedClientAgents, selectedClientStrategists, selectedClientTimings, selectedClientSuburbs } = this.state
    if (type === "filterStatusHead") {
      selectedClientStatus = filter(selectedClientStatus, status => status !== id)
    }
    if (type === "filterStrategistHead") {
      selectedClientStrategists = filter(selectedClientStrategists, status => status !== id)
    }
    if (type === "filterTimingHead") {
      selectedClientTimings = filter(selectedClientTimings, status => status !== id)
    }
    if (type === "filterSuburbsHead") {
      selectedClientSuburbs = filter(selectedClientSuburbs, status => status !== id)
    }
    if (type === "filterDateHead") {
      this.state.startDate = ""
      this.state.endDate = ""
      startDate = this.state.startDate
      endDate = this.state.endDate
    }
    if (type == 'filterAgentHead') {
      selectedClientAgents = filter(selectedClientAgents, agent => agent !== id)
    }

    this.filterUserRef.current.resetHeadFilterParams({ 
      selectedClientStatus, 
      selectedClientStrategists, 
      selectedClientTimings, 
      selectedClientSuburbs,
      selectedClientAgents,
      startDate,
      endDate 
    })

    if (this.newClientRef.current) this.newClientRef.current.setfilterParams({
      clientStatus: selectedClientStatus, 
      clientStrategist: selectedClientStrategists, 
      clientTiming: selectedClientTimings, 
      clientSuburb: selectedClientSuburbs, 
      clientAgent: selectedClientAgents,
      startDate, 
      endDate
    })



    if (this.allClientRef.current) this.allClientRef.current.setfilterParams({
      clientStatus: selectedClientStatus, 
      clientStrategist: selectedClientStrategists, 
      clientTiming: selectedClientTimings, 
      clientSuburb: selectedClientSuburbs, 
      clientAgent: selectedClientAgents,
      startDate, 
      endDate
    })
    
    

    this.setState({ 
      filteredStrategists: selectedClientStrategists, 
      filteredTimings: selectedClientTimings,
      filteredAgents: selectedClientAgents,
      selectedClientStatus, 
      selectedClientStrategists, 
      selectedClientTimings, 
      selectedClientSuburbs, 
      selectedClientAgents,
      startDate, 
      endDate
    })

  }


  // when click on userfilter set filter data from filter user
  setfilterParams = (data) => {
    const { clientStatus, filteredStrategists, filteredAgents, filteredTimings, filteredSuburb, startDate, endDate, filterCount } = data
    this.setState({
      clientStatus,
      client: filteredStrategists,
      clientSuburb: filteredSuburb,
      clientAgent: filteredAgents,
      clientStrategist: filteredStrategists,
      clientTiming: filteredTimings,
      selectedClientStatus: clientStatus,
      selectedClientStrategists: filteredStrategists,
      selectedClientTimings: filteredTimings,
      selectedClientSuburbs: filteredSuburb,
      selectedClientAgents: filteredAgents,
      filterCount: filterCount ? filterCount : 0,
      startDate: startDate ? moment.utc(startDate).format('YYYY-MM-DD') : "",
      endDate: endDate ? moment.utc(endDate).format('YYYY-MM-DD') : ""
    }, () => this.fetchFilterResult())
    if (this.newClientRef.current) this.newClientRef.current.setfilterParams(data)
    if (this.allClientRef.current) this.allClientRef.current.setfilterParams(data)
    this.forceUpdate()
  }
  formatNumber = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  render() {
    const { clientsData, filterParams } = this.props;
    const { clientType, startDate, endDate, isLoading, filterCount } = this.state;
    const clientStatus = filterParams && filterParams.data && filterParams.data.statuses;
    const clientStrategists = filterParams && filterParams.data && filterParams.data.strategists;
    const clientAgents = filterParams && filterParams.data && filterParams.data.agents;
    const clientTimings = this.state.timingsData;
    const clientSuburbs = filterParams && filterParams.data && filterParams.data.suburbs;
    const { resultEntry } = this.state;
    const allClients = get(clientsData, `user_counts.all_clients`, 0);
    const myClients = get(clientsData, `user_counts.my_clients`, 0);
    const currentUrl = get(this.props, "location.pathname", "")
    const user = cookies.get("user") || {};
    return (
      <div className="layout-has-sidebar">
        <AdministrationSidebarNavigation {...this.props} />
        <TopNavigation {...this.props} />
        <main className="dashboard-layout-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <h2 className="heading-title">
                  <span className="heading-icon"><ClientsColorIcon className="" /></span>
                  Clients
                </h2>
              </div>

              <div className="col-md-6">
                <div className="filter__result__section">
                  <Link to={'/strategist/add-client'} className="btn btn__btn btn-dark btn__add__new__client">Add New Client</Link>
                  {/* This is for filter section */}
                  
                  <FilterUser 
                    ref={this.filterUserRef}
                    resultEntry={resultEntry} 
                    {...this.props} 
                    setfilterParams={this.setfilterParams} t
                    timings={this.state.timingsData} />
                  {/* End filter section */}
                  <SelectPageResult handlePageChange={this.handleResultChange} />
                </div>
              </div>
            </div>
            {/*<ExportClients */}
            {/*  dataSource = { this.fetchAlldata } */}
            {/*  disabled = { !filterCount && (!startDate && !endDate) } */}
            {/*  hide = { !(clientsData.users || []).length || user.role !== 'superadmin' && user.role !== 'admin' } */}
            {/*/>*/}
            <div className="mob__view__container mob__view__control">
              <div className="col-md-12">
                <select
                  className="form-control custom__select mt__20 mb__20"
                  onChange={this.changePropsForMobile.bind(this)}
                  value={clientType}
                >
                  <option value="my_clients">New Clients (Created in last 48 hours)</option>
                  <option value="all_clients">All Clients</option>
                </select>
                <ul className="filter__list__flitered">
                  {clientStatus && map(clientStatus, (status, index) => {
                    const findSelected = find(this.state.selectedClientStatus, o => o === status.name)
                    if (findSelected && size(findSelected)) {
                      return (<li key={index}>{status.name}<span onClick={this.filterStrategist.bind(this, status.name, 'filterStatusHead')}><CloseIcon className="close-icon" /></span></li>)
                    }
                  })}
                  {clientTimings && map(clientTimings, (timing, index) => {
                    const findSelected = find(this.state.selectedClientTimings, o => o === timing.id)
                    if (findSelected) {
                      return (<li key={index}>{timing.name}<span onClick={this.filterStrategist.bind(this, timing.id, 'filterTimingHead')}><CloseIcon className="close-icon" /></span></li>)
                    }
                  })}
                  {clientStrategists && map(clientStrategists, (strategist, index) => {
                    const findSelected = find(this.state.selectedClientStrategists, o => o === strategist.id)
                    if (findSelected) {
                      return (<li key={index}>{strategist.strategist_name}<span onClick={this.filterStrategist.bind(this, strategist.id, 'filterStrategistHead')}><CloseIcon className="close-icon" /></span></li>)
                    }
                  })}
                  {clientSuburbs && map(clientSuburbs, (suburb, index) => {
                    const findSelected = find(this.state.selectedClientSuburbs, o => o === suburb.id)
                    if (findSelected) {
                      return (<li key={index}>{suburb.name}<span onClick={this.filterStrategist.bind(this, suburb.id, 'filterSuburbsHead')}><CloseIcon className="close-icon" /></span></li>)
                    }
                  })}
                </ul>
              </div>
            </div>

            <div className="desktop__view">
              <div className="row">
                <div className="col-md-12">
                  <div className="tabs__control">
                    <button
                      className={`btn btn-link ${(currentUrl === '/strategist/clients/new-clients' || currentUrl === '/strategist/clients') && 'active'}`}
                      onClick={() => this.handleRouteChange('new-clients')}>
                      New Clients(Created in last 48 hours) <span>{this.formatNumber(myClients)} Clients</span>
                    </button>
                    <button
                      className={`btn btn-link ${currentUrl === '/strategist/clients/all-clients' && 'active'}`}
                      onClick={() => this.handleRouteChange('all-clients')}>
                      All Clients <span>{this.formatNumber(allClients)} Clients</span>
                    </button>
                  </div>
                </div>
              </div>
              <ul className="filter__list__flitered">
                {clientStatus && map(clientStatus, (status, index) => {
                  const findSelected = find(this.state.selectedClientStatus, o => o === status.name)
                  if (findSelected && size(findSelected)) {
                    return (<li key={index}>Status: {status.name}<span onClick={this.filterStrategist.bind(this, status.name, 'filterStatusHead')}><CloseIcon className="close-icon" /></span></li>)
                  }
                })}
                {clientTimings && map(clientTimings, (timing, index) => {
                  const findSelected = find(this.state.selectedClientTimings, o => o === timing.name)
                  if (findSelected) {
                    return (<li key={index}>{timing.name}<span onClick={this.filterStrategist.bind(this, timing.name, 'filterTimingHead')}><CloseIcon className="close-icon" /></span></li>)
                  }
                })}
                {clientStrategists && map(clientStrategists, (strategist, index) => {
                  const findSelected = find(this.state.selectedClientStrategists, o => o === strategist.id)
                  if (findSelected) {
                    return (<li key={index}>Strategist: {strategist.strategist_name}<span onClick={this.filterStrategist.bind(this, strategist.id, 'filterStrategistHead')}><CloseIcon className="close-icon" /></span></li>)
                  }
                })}
                {clientSuburbs && map(clientSuburbs, (suburb, index) => {
                  const findSelected = find(this.state.selectedClientSuburbs, o => o === suburb.id)
                  if (findSelected) {
                    return (<li key={index}>Suburb: {suburb.name}<span onClick={this.filterStrategist.bind(this, suburb.id, 'filterSuburbsHead')}><CloseIcon className="close-icon" /></span></li>)
                  }
                })}
                {(startDate !== "" && endDate !== "") &&
                  (<li>{moment.utc(startDate).format('MM/DD/YYYY')}-{moment.utc(endDate).format('MM/DD/YYYY')}<span onClick={this.filterStrategist.bind(this, "date", 'filterDateHead')}><CloseIcon className="close-icon" /></span></li>)
                }
                {clientAgents && map(clientAgents, (agent, index) => {
                  const findSelected = find(this.state.selectedClientAgents, a => a === agent.id)
                  if (findSelected) {
                    return (<li key={index}>Agent: {agent.agent_name}<span onClick={this.filterStrategist.bind(this, agent.id, 'filterAgentHead')}><CloseIcon className="close-icon" /></span></li>)
                  }
                })}

                {/* START HERE:  SJ-616
                  - Add working close behavior to agent bubbles
                */}
              </ul>

            </div>
            {/* exact routes for show tab on strategist/client url */}
            <ClientContext.Provider 
              value={{isClientDataFetching: this.state.isClientDataFetching}}>
            <Switch>             
              <Route exact path={`/strategist/clients`}>
                <NewClients {...this.props}
                  ref={this.newClientRef}
                  fetchFilterResult={this.fetchFilterResult}
                  resultEntry={this.state.resultEntry}
                  isLoading={this.state.isLoading}
                />
              </Route>
              <Route exact path={`/strategist/clients/new-clients`}>
                <NewClients {...this.props}
                  ref={this.newClientRef}
                  fetchFilterResult={this.fetchFilterResult}
                  resultEntry={this.state.resultEntry}
                  isLoading={this.state.isLoading}
                />
              </Route>
              <Route exact path={`/strategist/clients/all-clients`}>
                <AllClients {...this.props}
                  ref={this.allClientRef}
                  fetchFilterResult={this.fetchFilterResult}
                  resultEntry={this.state.resultEntry}
                  isLoading={this.state.isLoading}
                />
              </Route>
            </Switch>
              </ClientContext.Provider>
          </div>
        </main>
      </div>
    )
  }
}
